export enum EPaymentMethod {
  PAYPAL = "paypal",
  CREDIT_CARD = "credit_card",
  NONE = "none",
}
